export function getQuerysByArray(date, preArray) {
  const count = preArray.length;
  let str = '';
  for (let i = 0; i < count; i++) {
    const item = date[i]?.toISOString();
    if (item && preArray[i].length > 0) {
      str = str + (str.length === 0 ? '?' : '&') + preArray[i] + '=' + item;
    }
  }
  return str;
}

export function getBodyByArray(date, preArray) {
  const count = preArray.length;
  const dic = {};
  for (let i = 0; i < count; i++) {
    const item = date[i]?.toISOString();
    if (item && preArray[i].length > 0) {
      dic[preArray[i]] = item;
    }
  }
  return dic;
}
